import React from 'react';

/**
 * Prose wrapper for PA-generated content. Ensures consistent typography,
 * smarter line-wrapping (`text-wrap: pretty`), and tighter vertical rhythm.
 * Children can include arbitrary inline JSX - Citations, entity tags, etc.
 */
export function PAText({ children }: { children: React.ReactNode }) {
  return (
    <span
      style={{
        textWrap: 'pretty',
        lineHeight: 1.65,
      }}
    >
      {children}
    </span>
  );
}
